import React, { useMemo } from 'react';
import { Button } from 'react-bootstrap';

import { useUserContext } from 'providers/UserProvider';
import Table from 'components/common/Table';
import GatePassCreateModal from './GatePassCreateModal';
import { gatePassApi } from 'api';
import { getGatePassListColumns } from 'constants/gatepass';

const GatePassListPage = () => {
  const { selectedTenant, selectedWarehouse } = useUserContext();
  const tenant = selectedTenant?.domains?.[0]?.domain;
  const warehouse = selectedWarehouse?.domain;

  const columns = useMemo(() => {
    return getGatePassListColumns(tenant, warehouse);
  }, [tenant, warehouse]);

  const headerActions = (
    <GatePassCreateModal>
      <Button variant="primary" size="sm">
        Create GatePass
      </Button>
    </GatePassCreateModal>
  );

  return (
    <Table
      title="GatePass List"
      apiService={gatePassApi}
      columns={columns}
      headerActions={headerActions}
      sortable
      fetchConfig={{ method: 'list' }}
    />
  );
};

export default GatePassListPage;
